export const fileSizeInMB = (fileSize) => {
  let totalSizeMB = fileSize / Math.pow(1024, 2);
  totalSizeMB = +totalSizeMB.toFixed(2);
  return totalSizeMB + ' Mb';
};

/**
 * Format a numeric value as a currency string in Australian Dollars (AUD).
 *
 * @param {number} value - The numeric value to be formatted as currency.
 */

export const currencyFormat = (value) => {
  const sign = Math.sign(value) === -1 ? '-' : '';
  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
  });
  const formattedValue = formatter.format(Math.abs(value));
  return `${sign}${formattedValue}`;
};

export const sortBy = (data, key, isAsc) => {
  if (!key) return data;
  if (!data && data?.length === 0) return [];
  if (isAsc) return data.sort((a, b) => (a[key] > b[key] ? 1 : -1));
  if (!isAsc) return data.sort((a, b) => (a[key] > b[key] ? -1 : 1));
};

export const getPortalType = (accountNumber) => {
  return /^05/.test(accountNumber) ? 'cash' : 'card';
};

/**
 * Normalizes an array of options into objects with label and value keys.
 * If the array elements are not objects with label and value keys,
 * converts them into objects with label and value keys.
 * @param {Array} arr - The array to be normalized.
 * @returns {Array} - The normalized array of objects with label and value keys.
 */
export const normaliseArray = (arr) => {
  // Check if every element is an object with label and value keys
  if (arr.every((item) => typeof item === 'object' && 'label' in item && 'value' in item)) {
    return arr;
  } else {
    // If not in the expected format, convert each element into an object
    return arr.map((item) => {
      // If item is not an object, convert it into an object with label and value keys
      if (typeof item !== 'object') {
        return { label: item, value: item };
      } else {
        return item; // If already an object, return as is
      }
    });
  }
};

export const clamp = (value, min, max) => {
  return Math.min(Math.max(value, min), max);
};

export const getAccountLevelName = (value) => {
  return value === 'A' ? 'Grandparent' : value === 'B' ? 'Parent' : 'Child';
};

export const capitalize = (text) => {
  return text.toLowerCase().charAt(0).toUpperCase() + text.slice(1);
};
